<fw-dialog class="expired-api-keys-dialog" width="small">
  <fw-dialog-header>
    <fw-icon color="red">warning-circle</fw-icon>
    <h3>API Keys and Certificates are Expiring!</h3>
  </fw-dialog-header>
  <fw-dialog-content>
    <div class="expired-api-keys-dialog-content">
      @if (userKeys.length) {
        <section>
          <h4>User API Keys</h4>
          <p class="expired-api-keys-dialog-content-subtitle">
            To manage, visit your
            <a class="expired-api-keys-dialog-content-link" href="#/profile" test-id="expired-api-keys-profile-link"
              >profile</a
            >
            page.
          </p>
          <div class="key-list">
            @for (key of userKeys; track key.key) {
              <div class="key-row">
                <div class="key-name">
                  <fw-icon>key</fw-icon>
                  <p>{{ key.label }}</p>
                </div>
                <div class="key-expiry">
                  <fw-icon>warning-circle</fw-icon>
                  <p>{{ key.isExpired ? 'Expired' : 'Expires in ' + key.formattedDate }}</p>
                </div>
              </div>
            }
          </div>
        </section>
      }

      @if (deviceKeys.length) {
        <section>
          <h4>Device API Keys</h4>
          <p class="expired-api-keys-dialog-content-subtitle">
            To manage, visit the
            <a
              class="expired-api-keys-dialog-content-link"
              href="#/admin/interfaces"
              test-id="expired-api-keys-interfaces-link"
              >Interfaces - Devices</a
            >
            page.
          </p>
          <div class="key-list">
            @for (key of deviceKeys; track key.key) {
              <div class="key-row">
                <div class="key-name">
                  <fw-icon>key</fw-icon>
                  <p>{{ key.label }}</p>
                </div>
                <div class="key-expiry">
                  <fw-icon>warning-circle</fw-icon>
                  <p>{{ key.isExpired ? 'Expired' : 'Expires in ' + key.formattedDate }}</p>
                </div>
              </div>
            }
          </div>
        </section>
      }

      @if (deviceMTLSCertificates.length) {
        <section>
          <h4>Device Certificates</h4>

          <p class="expired-api-keys-dialog-content-subtitle">
            To manage, visit the
            <a
              class="expired-api-keys-dialog-content-link"
              href="#/admin/interfaces/connector/manage-connections"
              test-id="expired-api-keys-connector-link"
              >Interfaces - Connector</a
            >
            page.
          </p>
          <div class="key-list">
            @for (key of deviceMTLSCertificates; track key.key) {
              <div class="key-row">
                <div class="key-name">
                  <fw-icon>key</fw-icon>
                  <p>{{ key.label }}</p>
                </div>
                <div class="key-expiry">
                  <fw-icon>warning-circle</fw-icon>
                  <p>{{ key.isExpired ? 'Expired' : 'Expires in ' + key.formattedDate }}</p>
                </div>
              </div>
            }
          </div>
        </section>
      }
    </div>
  </fw-dialog-content>
  <fw-dialog-actions>
    <fw-checkbox [(ngModel)]="doNotShow">
      <span class="expired-api-keys-dialog-checkbox-title">Do not show again for these keys and certificates.</span>
    </fw-checkbox>
    <fw-button test-id="expired-api-keys-dismiss-btn" (click)="close()"> Dismiss </fw-button>
  </fw-dialog-actions>
</fw-dialog>
